import React from 'react';
import PropTypes from 'prop-types';
import { AceCodeEditor } from '@ion/components';

export default function ServerResponseError({ error }) {
  return (
    <AceCodeEditor
      rows={30}
      name="server-response-error"
      readOnly
      lang="text"
      value={error}
      errorMsg="Error during request"
    />
  );
}

ServerResponseError.propTypes = {
  error: PropTypes.string.isRequired,
};
